"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ContentGroup;
const react_1 = __importDefault(require("react"));
const tab_group_1 = require("~/components/tab-group/tab-group");
function ContentGroup({ activeIndex, labels, children }) {
    return (react_1.default.createElement("div", { className: "content-group" }, react_1.default.Children.map(children, (child, i) => (react_1.default.createElement(Panel, { label: labels[i], key: i, active: activeIndex === i }, child)))));
}
function Panel({ label, active, children }) {
    const id = (0, tab_group_1.ariaPanelId)(label);
    const tabId = (0, tab_group_1.ariaTabId)(label);
    return (react_1.default.createElement("div", { id: id, "aria-labelledby": tabId, hidden: !active, role: "tabpanel" }, children));
}
